import store from "@/store";

export default {
  bind(el, binding, vnode) {
    const theme = store.state.themeClass;
    theme && el.classList.add(theme);
    console.log("🚀 ~ file: theme.js:7 ~ bind ~ theme:", theme, el.classList)
  },
};
